// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02533df6","455":"30993689","586":"d5512e15","762":"ea70359e","977":"bd9d18f1"}[chunkId] + ".chunk.js";
};